import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { APIResponseWrapper } from '../models/common/api-response-wrapper';

export interface LocationImportRow {
  rowNumber: number;
  values: Record<string, string>;
  action: 'CREATE' | 'UPDATE';
  issues: string[];
}

export interface LocationImportBatch {
  id: number;
  owningCompanyId: number;
  fileName: string;
  status: 'DRAFT' | 'CONFIRMED';
  totalRows: number;
  validRows: number;
  invalidRows: number;
  createdAt: string;
  confirmedAt?: string;
  rows?: LocationImportRow[];
}

@Injectable({ providedIn: 'root' })
export class LocationImportService {
  private readonly url = `${environment.restApiUrl}location-import`;
  constructor(private readonly http: HttpClient) {}

  template(companyId: number): Observable<Blob> {
    return this.http.get(`${this.url}/template`, {
      params: { owningCompanyId: companyId }, responseType: 'blob'
    });
  }

  upload(companyId: number, file: File): Observable<APIResponseWrapper<LocationImportBatch>> {
    const body = new FormData();
    body.append('owningCompanyId', String(companyId));
    body.append('file', file);
    return this.http.post<APIResponseWrapper<LocationImportBatch>>(`${this.url}/batches`, body);
  }

  history(companyId: number): Observable<APIResponseWrapper<LocationImportBatch[]>> {
    return this.http.get<APIResponseWrapper<LocationImportBatch[]>>(`${this.url}/batches`,
      { params: { owningCompanyId: companyId } });
  }

  batch(companyId: number, batchId: number): Observable<APIResponseWrapper<LocationImportBatch>> {
    return this.http.get<APIResponseWrapper<LocationImportBatch>>(`${this.url}/batches/${batchId}`,
      { params: { owningCompanyId: companyId } });
  }

  confirm(companyId: number, batchId: number): Observable<APIResponseWrapper<LocationImportBatch>> {
    return this.http.post<APIResponseWrapper<LocationImportBatch>>(`${this.url}/batches/${batchId}/confirm`, {},
      { params: { owningCompanyId: companyId } });
  }
}
